import React from "react";
import {RespContext} from '../providers';

function useResp() {
    return React.useContext(RespContext);
}

export {useResp}
